import { Auslandsrisiko } from '@ps20/bff-models';
import { Auslandsrisikoort, isAuslandsrisikoort, Risikoort } from './risikoort';
import { App } from './ps20apps';
import { areAppTypesEquivalent } from './app-type-config';

export interface Adressvorschlag {
  orte: Array<string>;
  strassen: Array<string>;
  lastError: ADRESSVORSCHLAG_FAILED_REASON;
}

export enum ADRESSVORSCHLAG_FAILED_REASON {
  SERVICEDOWN = 'SERVICEDOWN',
  ADRESS_INVALID = 'ADRESS_INVALID',
  PLZ_INVALID = 'PLZ_INVALID',
}

export function isRisikoortNotAvailable(risikoort: Risikoort, appId: App): boolean {
  const isAuslaendischeRisikoort = isAuslandsrisikoort(risikoort);
  if (isAuslaendischeRisikoort) {
    const auslandsrisikoort = risikoort as Auslandsrisikoort;
    if (
      auslandsrisikoort.auslandsadresse ||
      auslandsrisikoort.isImmobilieImAusland ||
      (auslandsrisikoort.auslandsrisiko &&
        auslandsrisikoort.auslandsrisiko !== Auslandsrisiko.RISIKO_DEUTSCHLAND)
    ) {
      return false;
    }
  }
  if (areAppTypesEquivalent(appId, App.VWG)) {
    if (risikoort.longtitude && risikoort.latitude) {
      return !risikoort.plz || !risikoort.ort || !risikoort.strasse;
    } else {
      return !risikoort.plz || !risikoort.ort || !risikoort.strasse || !risikoort.hausnummer;
    }
  } else if (areAppTypesEquivalent(appId, App.VHV)) {
    return !risikoort.plz || !risikoort.strasse;
  }
  return !risikoort.plz;
}
